module.exports = __webpack_public_path__ + "img/individual-2@2x.df32aa6.png";